import Vue from 'vue';
import {mapState,mapActions} from 'vuex';
import $ from 'jquery' ;
import { Toast } from 'vant';
import http from '../../utils/config';
import Axios from 'axios';
let Base64 = require('js-base64').Base64;
import { PullRefresh } from 'vant';

Vue.use(PullRefresh);
export default {
  name: 'successSub',
  data() {
    return {

    };

  },
  updated(){


  },
  created() {

  },
  methods: {

    back() {
      // this.$router.go(-1);
      this.$router.push({name:'smart'})
    },
    toIndex(){
      this.$router.push({name:'smart'})
    },
    tohistory(){
      this.$router.push({name:'History'})
    }

  },

};
